import { decryptPayload } from "./cryptoService";

// What the gateway says to this tab over the heartbeat WebSocket (see sessionHeartbeat.js):
//   { type: "logout" }  SEALED with the session key: this login was ended (an admin's "End", or a logout in another tab).
//                       The tab signs out now instead of failing on its next call.
//   { type: "lock" }    PLAIN: the crypto session is gone (idle too long, or the laptop slept). There is no key left to seal
//                       it with. The tab asks for the MPIN right away instead of on the user's next click.
// A plain "logout" is ignored on purpose: it could have been written by anyone on the network. A plain "lock" can only
// ask for the MPIN, which the server checks anyway, so there is nothing to gain by faking it.
const NOTICE_KEY = "loginNotice";
const LOGOUT_NOTICE = "Your session was ended, so you were signed out. Please sign in again.";

let handlers = { onLogout: () => {}, onLock: () => {} };
let loggingOut = false;

export function setServerPushHandlers(next) {
  handlers = { ...handlers, ...next };
}

/** This tab is logging out by itself: the logout that comes back from the gateway must not log it out a second time. */
export function markLoggingOut() {
  loggingOut = true;
}

export function resetServerPushForTests() {
  handlers = { onLogout: () => {}, onLock: () => {} };
  loggingOut = false;
}

export function setLoginNotice(text) {
  try { sessionStorage.setItem(NOTICE_KEY, text); } catch { /* private mode: no notice */ }
}

/** The sign-in page shows this once ("Your session was ended...") and forgets it. */
export function takeLoginNotice() {
  try {
    const text = sessionStorage.getItem(NOTICE_KEY) || "";
    sessionStorage.removeItem(NOTICE_KEY);
    return text;
  } catch {
    return "";
  }
}

export async function handleServerFrame(raw) {
  let message;
  let wasSealed = false;
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object" && Object.keys(parsed).length === 1 && typeof parsed.data === "string") {
      message = await decryptPayload(parsed);
      wasSealed = true;
    } else {
      message = parsed;
    }
  } catch {
    return;
  }
  if (!message || typeof message !== "object") return;

  try {
    if (message.type === "logout" && wasSealed) {
      if (!loggingOut) handlers.onLogout(LOGOUT_NOTICE);
    } else if (message.type === "lock") {
      handlers.onLock();
    }
  } catch {
    /* a screen that is not mounted must never break the connection */
  }
}
